import idx from 'idx';
import { connect } from 'react-redux';

import VoteRevision from 'focus_groups/components/vote_revision';

export function mapStateToProps(state) {
  const vote = idx(state, _ => _.project.focusGroups.vote);
  const index = vote.currentRevisionIndex;
  const revision = idx(state, _ =>
    _.project.focusGroups.viewState.currentGroup.revisions[index].revision
  );
  return { ...revision };
}

export default connect(mapStateToProps)(VoteRevision);



// WEBPACK FOOTER //
// ./focus_groups/containers/vote_revision.js